const Email = () =>
  import(
    /* webpackChunkName: "system-gateway" */ '@/pages/system/gateway/email/index.vue'
  )
const CreateEmail = () =>
  import(
    /* webpackChunkName: "system-gateway" */ '@/pages/system/gateway/email/create.vue'
  )
const EditEmail = () =>
  import(
    /* webpackChunkName: "system-gateway" */ '@/pages/system/gateway/email/edit.vue'
  )


export default {
  path: 'email',
  meta: {
    label: 'email',
    auth: 'email'
  },
  component: {
    name: 'Email',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemGatewayEmail',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Email
    },
    {
      name: 'SystemCreateGatewayEmail',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateEmail
    },
    {
      name: 'SystemEditGatewayEmail',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditEmail,
      props: true
    }
  ]
}
